import React from 'react'

const EmbedSpotify: React.FC<{ url: string }> = ({ url }) => {
  const embedUrl = url.replace('open.spotify.com/', 'open.spotify.com/embed/')
  return (
    <iframe
      title="Spotify"
      src={embedUrl}
      width="100%"
      height="352"
      frameBorder="0"
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    />
  )
}

export default EmbedSpotify
